import { Metadata } from '../../../../utils/spds/metadata';
import Super from '../../core/button.gjs';
import styles from './destructive.module.scss';

const METADATA = Metadata.define({
  description: `
    Destructive button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Destructive Button',
});

export default class SpdsActionButtonDestructive extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-destructive';
  variantStyles = styles;
}

export const ACTION_BUTTON_DESTRUCTIVE_METADATA = SpdsActionButtonDestructive.metadata;
